/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useQuery } from "@apollo/client";
import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { isMobileScreen, localCartKey, permissions } from "../../common";
import MiniCart from "./MiniCart";
import Search from "./Search";
import queries from "../../queries";
import Signout from "../Signout";
import { ImportMainJs } from "../../helper/ImportScript";
import ProductCard from "../mini/ProductCard";
import { useSessionStorage } from "../../context/SessionStorageContext";
import { BsCart, BsSearch } from "react-icons/bs";

function Header({ dataSelf, error, refetch }) {
  const location = useLocation();
  const [cartSize, setCartSize] = useState(0);
  const cartButtonRef = useRef(null);

  // Function to programmatically trigger cart button click
  const triggerCartToggle = () => {
    if (cartButtonRef.current) {
      cartButtonRef.current.click();
    }
  };

  // Alternative function to manually toggle cart visibility
  const toggleCartVisibility = () => {
    const cartElement = document.querySelector(".navbar-cart");
    const buttonElement = cartButtonRef.current;

    if (cartElement && buttonElement) {
      cartElement.classList.toggle("active");
      buttonElement.classList.toggle("active");
    }
  };

  // Function to show cart
  const showCart = () => {
    const cartElement = document.querySelector(".navbar-cart");
    const buttonElement = cartButtonRef.current;

    if (cartElement && buttonElement) {
      cartElement.classList.add("active");
      buttonElement.classList.add("active");
    }
  };

  // Function to hide cart
  const hideCart = () => {
    const cartElement = document.querySelector(".navbar-cart");
    const buttonElement = cartButtonRef.current;

    if (cartElement && buttonElement) {
      cartElement.classList.remove("active");
      buttonElement.classList.remove("active");
    }
  };

  const { data: dataProductBrands } = useQuery(
    queries.products.GET_PRODUCT_BRANDS
  );
  const [productBrandDisplayNames, setProductBrandDisplayNames] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [productBrandParam, setProductBrandParam] = useState(
    searchParams.get("brand") || null
  );
  const [productSubtypeParam, setProductSubtypeParam] = useState(
    searchParams.get("subtype") || null
  );
  const [newSearchTerm, setNewSearchTerm] = useState(
    searchParams.get("search") || null
  );

  const { sessionData, updateSessionStorage, isUserLoggedIn, localCart } =
    useSessionStorage();
  const { data: dataTrending } = useQuery(
    queries.products.GET_PRODUCTS_BY_QUERY,
    {
      variables: {
        page: 1,
      },
    }
  );

  useEffect(() => {
    if (dataSelf?.getSelf?.cart?.length >= 0) {
      setCartSize(dataSelf?.getSelf?.cart?.length);
    }
  }, [dataSelf]);

  // Expose cart control functions to window object for easy access
  useEffect(() => {
    window.cartControls = {
      triggerCartToggle,
      toggleCartVisibility,
      showCart,
      hideCart,
    };

    // Cleanup on unmount
    return () => {
      delete window.cartControls;
    };
  }, []);

  useEffect(() => {
    if (dataProductBrands?.getProductBrands?.length >= 0) {
      const sortedBrandDisplayNames = dataProductBrands?.getProductBrands.sort(
        (a, b) => {
          if (a.display_name < b.display_name) return -1;
          if (a.display_name > b.display_name) return 1;
          return 0;
        }
      );

      const midIndex = Math.ceil(sortedBrandDisplayNames.length / 4);
      const firstCol = sortedBrandDisplayNames.slice(0, midIndex);
      const secondCol = sortedBrandDisplayNames.slice(midIndex, midIndex * 2);
      const thirdCol = sortedBrandDisplayNames.slice(
        midIndex * 2,
        midIndex * 3
      );
      const fourthCol = sortedBrandDisplayNames.slice(midIndex * 3);

      const rearrangedBrandDisplayNames = [];
      for (let i = 0; i < midIndex; i++) {
        if (firstCol[i]) rearrangedBrandDisplayNames.push(firstCol[i]);
        if (secondCol[i]) rearrangedBrandDisplayNames.push(secondCol[i]);
        if (thirdCol[i]) rearrangedBrandDisplayNames.push(thirdCol[i]);
        if (fourthCol[i]) rearrangedBrandDisplayNames.push(fourthCol[i]);
      }
      setProductBrandDisplayNames(rearrangedBrandDisplayNames);
    }
  }, [dataProductBrands]);

  useEffect(() => {
    setCartSize(localCart.length);
  }, [localCart]);

  useEffect(() => {
    if (dataTrending?.getProductsByQuery != null) {
      ImportMainJs();
    }
  }, [dataTrending]);

  function handleLogoutClick(e) {
    Signout();
  }

  function signInDropdown() {
    return (
      <li className="rd-nav-item">
        <a
          href={
            dataSelf?.getSelf == null
              ? `/login?redirect_url=${window.location.pathname}`
              : "javascript:void(0);"
          }
          className="rd-nav-link"
        >
          Hello,{" "}
          {dataSelf?.getSelf?.fname ? dataSelf?.getSelf?.fname : "Sign In"}
        </a>
        <ul className="rd-menu rd-navbar-dropdown">
          {dataSelf?.getSelf != null && (
            <>
              {dataSelf?.getSelf?.type?.role_access?.includes(
                permissions.MODIFY_PRODUCTS
              ) && (
                <li className="rd-dropdown-item">
                  <a className="rd-dropdown-link" href="/add-product">
                    Add Product
                  </a>
                </li>
              )}
              {dataSelf?.getSelf?.type?.role_access?.includes(
                permissions.MANAGE_ORDERS
              ) && (
                <li className="rd-dropdown-item">
                  <a className="rd-dropdown-link" href="/manage-orders">
                    Manage Orders
                  </a>
                </li>
              )}
              <li className="rd-dropdown-item">
                <a className="rd-dropdown-link" href="/my-orders">
                  My Orders
                </a>
              </li>
              <li className="rd-dropdown-item">
                <a
                  className="rd-dropdown-link"
                  href="javascript:void(0);"
                  onClick={handleLogoutClick}
                >
                  Logout
                </a>
              </li>
            </>
          )}
          {dataSelf?.getSelf == null && (
            <>
              <li className="rd-dropdown-item">
                <a
                  className="rd-dropdown-link"
                  href={`/login?redirect_url=${window.location.pathname}`}
                >
                  Login
                </a>
              </li>
              <li className="rd-dropdown-item">
                <a
                  className="rd-dropdown-link"
                  href={`/signup?redirect_url=${window.location.pathname}`}
                >
                  Sign Up
                </a>
              </li>
            </>
          )}
        </ul>
      </li>
    );
  }

  return (
    <>
      <header className="section page-header">
        <div className="rd-navbar-wrap">
          <div class="notification-bar mobilehide">
            <span class="notification-bar__message">
              FREE SHIPPING ON ALL ORDERS $50+
            </span>
          </div>
          <nav
            className="rd-navbar"
            data-layout="rd-navbar-fixed"
            data-sm-layout="rd-navbar-fixed"
            data-md-layout="rd-navbar-fixed"
            data-lg-layout="rd-navbar-fixed"
            data-xl-layout="rd-navbar-static"
            data-xxl-layout="rd-navbar-static"
            data-md-device-layout="rd-navbar-fixed"
            data-lg-device-layout="rd-navbar-fixed"
            data-xl-device-layout="rd-navbar-static"
            data-xxl-device-layout="rd-navbar-static"
            data-xl-stick-up-offset="1px"
            data-xxl-stick-up-offset="1px"
            data-xl-stick-up="true"
            data-xxl-stick-up="true"
          >
            <div className="rd-navbar-main-outer">
              <div className="rd-navbar-main">
                <div className="rd-navbar-main-col-left">
                  <div className="rd-navbar-nav-wrap">
                    <ul className="rd-navbar-nav">
                      {isMobileScreen() && signInDropdown()}
                      <li
                        className={`rd-nav-item ${
                          location.pathname === "/" ? "active" : ""
                        }`}
                      >
                        <a className="rd-nav-link" href="/">
                          Home
                        </a>
                      </li>
                      <li className="rd-nav-item">
                        <a className="rd-nav-link" href="/products">
                          Trending
                        </a>

                        <ul className="rd-menu rd-navbar-megamenu">
                          <li className="rd-megamenu-item">
                            <div className="container">
                              <div className="row">
                                <div className="col-xl-3">
                                  <div className="rd-megamenu-title">
                                    All Products
                                  </div>
                                  <ul className="rd-megamenu-list">
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/kratom"
                                      >
                                        Kratom
                                      </a>
                                    </li>
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/cbd"
                                      >
                                        CBD
                                      </a>
                                    </li>
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/delta8"
                                      >
                                        Hemp & Delta
                                      </a>
                                    </li>
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/mushroom"
                                      >
                                        Mushroom
                                      </a>
                                    </li>
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/glass"
                                      >
                                        Glass
                                      </a>
                                    </li>
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/hookah"
                                      >
                                        Hookah
                                      </a>
                                    </li>
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/7oh"
                                      >
                                        7-Hydroxymitragynine
                                      </a>
                                    </li>
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/rolling_paper"
                                      >
                                        Rolling Paper
                                      </a>
                                    </li>
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/hemp_wraps"
                                      >
                                        Hemp Wraps
                                      </a>
                                    </li>
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/torch_it"
                                      >
                                        Torch It
                                      </a>
                                    </li>
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/accessories"
                                      >
                                        Accessories
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                                <div className="col-xl-9 rd-megamenu-carousel-wrap">
                                  <div className="rd-megamenu-title">
                                    Customer Favorites
                                  </div>
                                  <div
                                    className="owl-carousel owl-theme owl-carousel-style-2"
                                    data-items="1"
                                    data-xl-margin="40"
                                    data-xs-items="2"
                                    data-sm-items="2"
                                    data-md-items="3"
                                    data-lg-items="3"
                                    data-owl='{"dots":true,"nav":false,"autoplayTimeout":3500,"margin":30,"stagePadding":0}'
                                  >
                                    {dataTrending?.getProductsByQuery?.map(
                                      (product) => {
                                        return (
                                          <ProductCard
                                            key={product?._id}
                                            product={product}
                                            refetch={refetch}
                                          />
                                        );
                                      }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </li>
                      <li
                        className={`rd-nav-item ${
                          productSubtypeParam?.length > 0 ? "active" : ""
                        }`}
                      >
                        <a className="rd-nav-link" href="/products">
                          Shop by category
                        </a>

                        <ul className="rd-menu rd-navbar-megamenu">
                          <li className="rd-megamenu-item">
                            <div className="container pb-4">
                              <div className="row">
                                <div className="col-xl-3">
                                  <div className="rd-megamenu-title">
                                    Kratom
                                  </div>
                                  <ul className="rd-megamenu-list">
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/kratom?subtype=liquid_extract_shots"
                                      >
                                        Liquid Extract Shots
                                      </a>
                                    </li>
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/kratom?subtype=powder"
                                      >
                                        Powder
                                      </a>
                                    </li>
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/kratom?subtype=capsules"
                                      >
                                        Capsules
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                                <div className="col-xl-3">
                                  <div className="rd-megamenu-title">CBD</div>
                                  <ul className="rd-megamenu-list">
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/cbd?subtype=edibles"
                                      >
                                        Edibles
                                      </a>
                                    </li>
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/cbd?subtype=hemp_cigarette"
                                      >
                                        Hemp Cigarettes
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                                <div className="col-xl-3">
                                  <div className="rd-megamenu-title">Glass</div>
                                  <ul className="rd-megamenu-list">
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/glass?subtype=waterpipe"
                                      >
                                        Waterpipe
                                      </a>
                                    </li>
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/glass?subtype=hand_pipe"
                                      >
                                        Hand Pipe
                                      </a>
                                    </li>
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/glass?subtype=rigs"
                                      >
                                        Rigs
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                                <div className="col-xl-3">
                                  <div className="rd-megamenu-title">
                                    Mushroom
                                  </div>
                                  <ul className="rd-megamenu-list">
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/mushroom?subtype=edibles"
                                      >
                                        Edibles
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-xl-3">
                                  <div className="rd-megamenu-title">
                                    Hemp & Delta
                                  </div>
                                  <ul className="rd-megamenu-list">
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/delta8?subtype=vape_disposables"
                                      >
                                        Vape Disposables
                                      </a>
                                    </li>
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/delta8?subtype=cartridges"
                                      >
                                        Cartridges
                                      </a>
                                    </li>
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/delta8?subtype=edibles"
                                      >
                                        Edibles
                                      </a>
                                    </li>
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/delta8?subtype=flowers"
                                      >
                                        Flowers
                                      </a>
                                    </li>
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/delta8?subtype=preroll"
                                      >
                                        Pre-Roll
                                      </a>
                                    </li>
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/hemp_wraps"
                                      >
                                        Hemp Wraps
                                      </a>
                                    </li>
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/delta8?subtype=vape_pens"
                                      >
                                        Vape Pens
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                                <div className="col-xl-3">
                                  <div className="rd-megamenu-title">
                                    7-Hydroxymitragynine
                                  </div>
                                  <ul className="rd-megamenu-list">
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/7oh?subtype=liquid_extract_shots"
                                      >
                                        Liquid Extract Shots
                                      </a>
                                    </li>
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/7oh?subtype=tablets"
                                      >
                                        Tablets
                                      </a>
                                    </li>
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/7oh?subtype=powder"
                                      >
                                        Powder
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                                <div className="col-xl-3">
                                  <div className="rd-megamenu-title">
                                    Rolling Paper
                                  </div>
                                  <ul className="rd-megamenu-list">
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/rolling_paper?subtype=ez_wider"
                                      >
                                        EZ Wider
                                      </a>
                                    </li>
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/rolling_paper?subtype=raw_papers"
                                      >
                                        Raw Papers
                                      </a>
                                    </li>
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/rolling_paper?subtype=bamboo_papers"
                                      >
                                        Bamboo Papers
                                      </a>
                                    </li>
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/rolling_paper?subtype=ez_wider_cone"
                                      >
                                        EZ Wider Cones
                                      </a>
                                    </li>
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/rolling_paper?subtype=raw_cone"
                                      >
                                        Raw Cones
                                      </a>
                                    </li>
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/rolling_paper?subtype=ocb_bamboo_cone"
                                      >
                                        OCB Bamboo Cone
                                      </a>
                                    </li>
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/rolling_paper?subtype=ez_other_brands"
                                      >
                                        EZ Other Brands
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                                <div className="col-xl-3">
                                  <div className="rd-megamenu-title">Other</div>
                                  <ul className="rd-megamenu-list">
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/torch_it"
                                      >
                                        Torch It
                                      </a>
                                    </li>
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/accessories"
                                      >
                                        Accessories
                                      </a>
                                    </li>
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/best_seller"
                                      >
                                        Best Sellers
                                      </a>
                                    </li>
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/new_arrival"
                                      >
                                        New Arrival
                                      </a>
                                    </li>
                                    <li className="rd-megamenu-list-item">
                                      <a
                                        className="rd-megamenu-list-link"
                                        href="/products/special_deals"
                                      >
                                        Special Deals
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </li>
                      <li
                        className={`rd-nav-item ${
                          productBrandParam?.length > 0 ? "active" : ""
                        }`}
                      >
                        <a className="rd-nav-link" href="/brands">
                          Shop by brand
                        </a>

                        <ul className="rd-menu rd-navbar-megamenu">
                          <li className="rd-megamenu-item">
                            <div className="container pb-4">
                              <div className="row">
                                {productBrandDisplayNames.map((name) => {
                                  const codedName = encodeURIComponent(name);
                                  return (
                                    <div className="col-xl-3">
                                      <ul className="rd-megamenu-list">
                                        <li className="rd-megamenu-list-item">
                                          <a
                                            className="rd-megamenu-list-link"
                                            href={`/products?brand=${codedName}`}
                                          >
                                            {name}
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          </li>
                        </ul>
                      </li>
                      {/* <li className="rd-nav-item">
                        <a className="rd-nav-link" href="/about-us">
                          About Us
                        </a>
                      </li> */}
                      <li className="rd-nav-item">
                        <a className="rd-nav-link" href="/blogs">
                          Blogs
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="rd-navbar-main-col-middle">
                  <div className="rd-navbar-panel">
                    <button
                      className="rd-navbar-toggle"
                      data-rd-navbar-toggle=".rd-navbar-nav-wrap"
                    >
                      <span></span>
                    </button>
                    <div className="rd-navbar-brand">
                      <a className="brand" href="/">
                        <img
                          src="/images/logo.svg"
                          alt=""
                          style={{ width: "100px" }}
                        />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="rd-navbar-main-col-right">
                  <div className="rd-navbar-widgets">
                    {isMobileScreen() && (
                      <>
                        <div className="rd-navbar-search">
                          <button
                            className={
                              "btn-small-icon rd-navbar-search-toggle rd-nav-link" +
                              (isMobileScreen() ? " p-0" : "")
                            }
                            data-custom-toggle=".rd-navbar-search"
                            data-custom-toggle-disable-on-blur="true"
                          >
                            <svg
                              className="icon-svg"
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M7.38077 0C11.4505 0 14.7615 3.31102 14.7615 7.38077C14.7615 9.16309 14.1265 10.7998 13.0708 12.0767L18 17.0059L17.0059 18L12.0767 13.0708C10.7998 14.1265 9.16309 14.7615 7.38077 14.7615C3.31102 14.7615 0 11.4505 0 7.38077C0 3.31102 3.31098 0 7.38077 0ZM7.38077 13.3557C10.6753 13.3557 13.3557 10.6753 13.3557 7.38077C13.3557 4.08621 10.6753 1.40586 7.38077 1.40586C4.08621 1.40586 1.40586 4.08621 1.40586 7.38077C1.40586 10.6753 4.08621 13.3557 7.38077 13.3557Z"></path>
                            </svg>
                            <span>Search</span>
                          </button>
                          <Search />
                        </div>
                      </>
                    )}
                    {!isMobileScreen() && (
                      <>
                        <div className="rd-navbar-search">
                          <form
                            className="input-group align-items-center form-wrap"
                            role="search"
                            onSubmit={(e) => {
                              e.preventDefault();
                              const value =
                                e.target.elements["search-input"].value.trim();
                              if (value) {
                                window.location.href = `/products?search=${encodeURIComponent(
                                  value
                                )}`;
                              }
                            }}
                          >
                            <input
                              id="search-input"
                              name="search-input"
                              type="text"
                              className="form-control form-input"
                              placeholder="Search..."
                              value={newSearchTerm}
                              onChange={(e) => setNewSearchTerm(e.target.value)}
                              aria-label="Search input"
                              style={{
                                height: "2.5rem",
                                borderRadius: "4px 0 0 4px",
                                borderRight: "none",
                                minHeight: "2.5rem",
                              }}
                            />
                            <button
                              className="btn btn-primary m-0 px-3 fa-solid fa-search"
                              type="submit"
                              style={{
                                height: "2.5rem",
                                borderRadius: "0 4px 4px 0",
                              }}
                            ></button>
                          </form>
                        </div>
                        <div className="rd-navbar-nav-wrap my-auto ml-4">
                          <ul className="rd-navbar-nav">{signInDropdown()}</ul>
                        </div>
                      </>
                    )}
                    <div className="rd-navbar-cart-wrap ml-4">
                      <button
                        ref={cartButtonRef}
                        id="my-cart-toggle-btn-header"
                        className="my-cart-btn"
                        data-rd-navbar-toggle=".navbar-cart"
                      >
                        <BsCart />
                        <span className="badge">{cartSize}</span>
                      </button>
                      <MiniCart
                        dataSelf={dataSelf}
                        refetch={refetch}
                        error={error}
                      />
                    </div>
                    {/* <div className="rd-navbar-cart-wrap mr-3">
                      <button
                        className="btn-small-icon rd-nav-link"
                        data-rd-navbar-toggle=".navbar-cart"
                      >
                        <svg
                          className="icon-svg"
                          width="26"
                          height="26"
                          viewBox="0 0 26 26"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect width="26" height="26" fill="white"></rect>
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M23.5623 5.89022H17.6717V4.06223C17.6722 3.37463 17.4888 2.69942 17.1405 2.10653C16.7923 1.51364 16.2918 1.02464 15.691 0.690162C15.0902 0.355688 14.4109 0.187911 13.7235 0.204209C13.036 0.220507 12.3654 0.420286 11.7812 0.782856C11.1969 0.420286 10.5263 0.220507 9.83885 0.204209C9.15141 0.187911 8.47211 0.355688 7.87131 0.690162C7.27051 1.02464 6.77006 1.51364 6.4218 2.10653C6.07354 2.69942 5.89014 3.37463 5.89058 4.06223V5.89022H1.62499C1.46338 5.89022 1.30838 5.95442 1.19411 6.06869C1.07983 6.18296 1.01562 6.33795 1.01562 6.49955V25.1857C1.01562 25.3473 1.07983 25.5023 1.19411 25.6166C1.30838 25.7308 1.46338 25.795 1.62499 25.795H17.0624C17.127 25.795 17.2308 25.7683 17.2909 25.7443L20.3123 24.4936L23.4145 25.7769C23.7839 25.8799 24.1821 25.5701 24.1717 25.1857V6.49955C24.1717 6.41953 24.1559 6.3403 24.1253 6.26637C24.0947 6.19244 24.0498 6.12527 23.9932 6.06869C23.9366 6.01211 23.8694 5.96722 23.7955 5.9366C23.7216 5.90598 23.6423 5.89022 23.5623 5.89022ZM16.453 4.06223V5.89022H13.6093V4.06223C13.6099 3.18191 13.3081 2.32808 12.7543 1.64374C13.1561 1.46765 13.5955 1.39449 14.0326 1.43087C14.4698 1.46725 14.891 1.61202 15.2582 1.8521C15.6254 2.09218 15.9269 2.41998 16.1355 2.80587C16.3441 3.19176 16.4532 3.62356 16.453 4.06223ZM12.3905 4.0625V5.89022H11.1718V5.89063H9.95305V5.89022H7.10932V4.06223C7.10909 3.62356 7.21822 3.19176 7.42683 2.80587C7.63544 2.41998 7.93696 2.09218 8.30412 1.8521C8.67128 1.61202 9.09249 1.46725 9.52967 1.43087C9.66226 1.41984 9.79506 1.41888 9.92695 1.42781C10.2132 1.44704 10.4948 1.5128 10.7605 1.62288C11.0809 1.75559 11.372 1.95009 11.6172 2.1953C11.8624 2.4405 12.0569 2.7316 12.1896 3.05198C12.1955 3.06621 12.2013 3.08048 12.2069 3.09479C12.3146 3.3676 12.3765 3.65811 12.3884 3.95457C12.3899 3.9905 12.3906 4.02648 12.3906 4.0625H12.3905ZM2.23436 24.5764V7.10888H16.453V24.5764H2.23436ZM22.9529 24.3038L20.4601 23.2743C20.3631 23.2501 20.2616 23.2501 20.1646 23.2743L17.6717 24.3038V7.10888H19.703V9.03832C19.703 9.19993 19.7672 9.35491 19.8814 9.46918C19.9957 9.58345 20.1507 9.64765 20.3123 9.64765C20.4739 9.64765 20.6289 9.58345 20.7432 9.46918C20.8575 9.35491 20.9217 9.19993 20.9217 9.03832V7.10888H22.9529V24.3038Z"
                          ></path>
                        </svg>
                        <span>Cart: {cartSize}</span>
                      </button>
                      <MiniCart
                        dataSelf={dataSelf}
                        refetch={refetch}
                        error={error}
                      />
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </header>
    </>
  );
}

export default Header;
